<app-component-wrapper class="w-50 flex-fill" compclass="flex-fill h-100">
    <div class="d-flex flex-column flex-fill" slot="start"  id="db-account-summary-view-container">
        <div class="header">Account Summary</div>
        <div class="d-flex flex-row align-items-center">    
            <mat-icon class="me-2 info-icon">info</mat-icon><h4 class="mb-0">Please get in touch with the smartMonday Contact Centre if you require a defined benefit estimate on <a href="tel:+1300 614 644">1300 614 644</a> or <a href="mailto:enquiry@smartmonday.com.au">enquiry&#64;smartmonday.com.au</a>.</h4>
        </div>        
    </div>
</app-component-wrapper>